<template>
  <v-row align="center">
    <v-col
      :cols="edit ? 10 : 12"
      class="pb-0"
    >
      <v-text-field
        v-model="text"
        :hide-details="hideDetails"
        outlined
        dense
        :error-messages="errorMessages"
        :label="label"
        v-on="$listeners"
      />
    </v-col>
    <v-col
      v-if="edit"
      :cols="edit ? 2 : 0"
    >
      <v-btn
        v-if="edit"
        icon
        small
        :disabled="!text"
        @click="apply"
      >
        <v-icon
          color="green"
          class="ma-2"
        >
          mdi-check
        </v-icon>
      </v-btn>
      <v-btn
        v-if="edit"
        icon
        small
        class="ma-2"
        @click="close"
      >
        <v-icon color="red">
          mdi-close
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: "",
    },
    edit: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: [String, Array],
      default: "",
    },
  },
  data() {
    return {
      text: "",
    };
  },
  watch: {
    value: {
      handler(val) {
        this.text = val;
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.$emit("close", false);
    },
    apply() {
      this.$emit("apply", this.text);
    },
  },
};
</script>
